import {
  GO_TO_SETTING,
  SET_DATA_SOURCE,
  RESET_DATA_SOURCE,
  SET_TEMP_VALUE,
  SET_TEMP_DATA_SOURCE,
  SET_ADD_GROUP_SOURCE,
  SET_ADD_GROUP_TEMP_VALUE,
  RESET_ADD_GROUP_SOURCE,
  RESET_OPERATE_GROUP,
  SET_OPERATE_GROUP,
  SET_EDIT_RECORD,
  SET_PLAN_NAME,
} from './mutationTypes';

export default {
  state: {
    settingParams: {},
    dataSource: [],
    originDataSource: [],

    tempValue: [],
    addGroupTempValue: [],

    addGroupSource: [],

    operateGroup: false,

    groupRecord: {},

    plan_name: '',
  },
  mutations: {
    [GO_TO_SETTING](state, param) {
      state.settingParams = param;
    },
    [SET_DATA_SOURCE](state, param) {
      state.dataSource = param.dataSource;
    },
    [SET_TEMP_VALUE](state, param) {
      state.tempValue = param.tempValue;
    },
    [RESET_DATA_SOURCE](state) {
      state.dataSource = [];
    },
    [SET_EDIT_RECORD](state, param) {
      state.groupRecord = param.record;
    },
    [SET_TEMP_DATA_SOURCE](state, param) {
      state.originDataSource = param.originDataSource;
    },
    [SET_ADD_GROUP_SOURCE](state, param) {
      state.addGroupSource = param.addGroupSource;
    },
    [RESET_ADD_GROUP_SOURCE](state) {
      state.addGroupSource = [];
    },
    [SET_ADD_GROUP_TEMP_VALUE](state, param) {
      state.addGroupTempValue = param.tempValue;
    },
    [RESET_OPERATE_GROUP](state) {
      state.operateGroup = false;
    },
    [SET_OPERATE_GROUP](state, param) {
      state.operateGroup = param.operateGroup;
    },

    [SET_PLAN_NAME](state, plan_name) {
      state.plan_name = plan_name;
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/plan.js